import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Validator } from 'src/infrastructure/validation/validator';
import { Return } from 'src/models/requestModels/returns/return';
import { HistoryService } from 'src/services/state/history/history.service';
import { ReturnService } from 'src/services/state/return/return.service';
import { validateIBAN } from 'ngx-iban-validator';

@Component({
  selector: 'app-return-user-data',
  templateUrl: './return-user-data.component.html',
  styleUrls: ['./return-user-data.component.css']
})
export class ReturnUserDataComponent extends HistoryBaseComponent implements OnInit {


  private _oderUUID = '';
  private _cartLineUUID = '';
  private _returnInfo?: Return;
  private _paymentData: FormGroup;


  constructor(
    private FB: FormBuilder,
    private returnState: ReturnService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    protected location: Location,
    protected historyService: HistoryService,
  ) { 
    super(location, historyService);
    this.returnState.returnInfo$.subscribe(returnInfo => {
      this._returnInfo = returnInfo
    })
    this._paymentData = this.FB.group({
      iban: [this._returnInfo?.iban || '', [Validators.required, this.validateIban]],
      bank: [this._returnInfo?.bank || '', [Validators.required]],
      name: [this._returnInfo?.name || '', [Validators.required]]
    })
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this._oderUUID = params.orderUUID;
      this._cartLineUUID = params.cartLineUUID;
    })
  }

  get paymentData() {
    return this._paymentData;
  }

  private  validateIban(control: AbstractControl): ValidationErrors | null {
    if (control.value && validateIBAN( { value: control.value } )?.ibanInvalid) {
      return {ibanInvalid: {value: control.value}}
    }
    return null;
  }

  public return() {
    this._returnInfo!.bank = this._paymentData.get('bank')?.value;
    this._returnInfo!.iban = this._paymentData.get('iban')?.value;
    this._returnInfo!.name = this._paymentData.get('name')?.value;
    this.returnState.addNewOrderInfo(this._returnInfo!)
    this.router.navigate(['return/info/' + this._oderUUID + '/' + this._cartLineUUID])
  }

}
